import { defineStore } from 'pinia'

type LoadingBackground = 'dimmed'|'white'|'transparent';

interface LoadingState {
  loading: boolean;
  fullscreen: boolean;
  background: LoadingBackground;
  title: string;
  description: string;
}

const initailState: LoadingState = {
  loading: false,
  fullscreen: false,
  background: 'dimmed',
  title: '',
  description: ''
}

export const useLoadingStore = defineStore('loading', {
  state: () => initailState,
  actions: {
    setLoading (
      on: boolean,
      {
        fullscreen,
        background,
        title,
        description
      }: {
        fullscreen?: boolean,
        background?: LoadingBackground,
        title?: string,
        description?: string
      } = {}
    ) {
      this.loading = on
      this.fullscreen = fullscreen ?? false
      this.background = background ?? 'dimmed'
      this.title = title ?? ''
      this.description = description ?? ''
    }
  }
})
